export const APP_NAME = 'Smaregi ReceiptMaster'
export const APP_VERSION = '1.2.0'
export const COPYRIGHT = '© Smaregi, Inc.'
